import { Link } from 'react-router-dom';
import { Download, ArrowLeft, UtensilsCrossed } from 'lucide-react';
import { GEET_SET_MENU, GEET_SET_MENU_PDF } from '../data/geetSetMenu';

export default function GeetSetMenuPage() {
  return (
    <main data-testid="geet-set-menu" className="bg-[#FAF6F0] text-[#1C1917] min-h-screen">
      {/* Hero */}
      <section className="relative bg-[#1C1917] pt-32 md:pt-40 pb-16 md:pb-20 px-6 text-center overflow-hidden">
        <div className="absolute -top-24 right-1/4 w-80 h-80 rounded-full bg-[#C9A227] opacity-20 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 left-1/4 w-80 h-80 rounded-full bg-[#C9A227] opacity-10 blur-3xl pointer-events-none" />
        <div className="relative max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#C9A227]" />
            <span className="font-['Cormorant_Garamond'] italic text-[#C9A227] text-sm tracking-[0.4em] uppercase">For a Limited Time</span>
            <span className="h-px w-12 bg-[#C9A227]" />
          </div>
          <h1 className="font-['Marcellus'] text-4xl md:text-6xl text-[#FAF6F0] mb-4 leading-tight">
            Restaurant Week <span className="italic font-['Cormorant_Garamond'] text-[#FFE7A8]">Set Menu</span>
          </h1>
          <p className="font-['Cormorant_Garamond'] italic text-lg md:text-xl text-[#FAF6F0]/80 max-w-xl mx-auto mb-8">
            A chef-curated celebration of Indian fine dining — three gourmet set menus to choose from.
          </p>
          <a
            href={GEET_SET_MENU_PDF}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="geet-setmenu-download"
            className="group inline-flex items-center gap-3 bg-[#C9A227] text-[#1C1917] px-8 py-4 font-['Cormorant_Garamond'] tracking-[0.25em] uppercase text-sm font-semibold rounded-lg hover:bg-[#FAF6F0] transition-all duration-300 shadow-lg"
          >
            <Download size={17} /> Download PDF
          </a>
        </div>
      </section>

      {/* Menus */}
      <section className="max-w-6xl mx-auto px-6 py-14 md:py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {GEET_SET_MENU.map((menu, mi) => (
            <div
              key={menu.name}
              data-testid={`geet-setmenu-card-${mi}`}
              className="bg-white rounded-2xl border border-[#C9A227]/25 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col"
            >
              <div className="bg-[#1C1917] px-6 py-6 text-center">
                <div className="inline-flex items-center gap-2 text-[#C9A227] mb-2">
                  <UtensilsCrossed size={15} />
                  <span className="font-['Cormorant_Garamond'] italic text-xs tracking-[0.3em] uppercase">{menu.courses}</span>
                </div>
                <h2 className="font-['Marcellus'] text-2xl text-[#FAF6F0]">{menu.name}</h2>
              </div>
              <div className="p-6 flex-1">
                <ul className="space-y-5">
                  {menu.items.map((item, ii) => (
                    <li key={ii} data-testid={`geet-setmenu-item-${mi}-${ii}`}>
                      <p className="font-['Cormorant_Garamond'] italic text-[11px] tracking-[0.3em] uppercase text-[#C9A227] mb-1">{item.course}</p>
                      {item.dishes.map((d, di) => (
                        <div key={di}>
                          <p className="font-['Marcellus'] text-base md:text-lg text-[#1C1917] leading-snug">{d.name}</p>
                          {d.desc && <p className="font-['Cormorant_Garamond'] text-sm text-[#78716c] italic mt-0.5 leading-relaxed">{d.desc}</p>}
                        </div>
                      ))}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <p className="font-['Cormorant_Garamond'] italic text-lg text-[#57534e] mb-6">Reserve your table and mention "Restaurant Week".</p>
          <Link
            to="/geet/contact"
            data-testid="geet-setmenu-reserve"
            className="inline-flex items-center gap-3 bg-[#1C1917] text-[#C9A227] px-8 py-4 font-['Cormorant_Garamond'] tracking-[0.25em] uppercase text-sm font-semibold rounded-lg hover:bg-[#C9A227] hover:text-[#1C1917] transition-all duration-300"
          >
            Reserve a Table
          </Link>
          <div className="mt-8">
            <Link to="/geet" data-testid="geet-setmenu-back" className="inline-flex items-center gap-2 text-[#78716c] hover:text-[#C9A227] font-['Cormorant_Garamond'] italic text-sm">
              <ArrowLeft size={15} /> Back to Geet home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
